import { ApiCall } from "components/common/services/ApiServices";
import {
  BILLING_DETAILS,
  GET_PLANNING_COEFF_DETAILS,
  SET_DROPDOWN_DATA,
  UPDATE_FIELDS,
} from "../../annotation/PlanningConstants";
import { COMPANY_MICROSERVICE } from "Constants";
import CustomNotify from "components/common/atoms/CustomNotify";
import { t } from "components/CentralDataMangement/translation/Translation";

export const fetchCoeffDetails = async (
  type: "coeff", // Dynamic type handling
  id: number | null | undefined,
  dispatch: React.Dispatch<any>
) => {
  const data = { type, id };

  if (id) {
    const response = await ApiCall.service(
      `${GET_PLANNING_COEFF_DETAILS}`,
      "POST",
      data,
      false,
      COMPANY_MICROSERVICE
    );

    if (response?.status === 200) {
      const responseData = response?.data;
      if (Object.keys(responseData).length > 0) {
        dispatch({ type: SET_DROPDOWN_DATA, payload: responseData });
      }
    } else {
      CustomNotify({
        type: "error",
        message: t("Some error occured"),
      });
    }
  }
};

export const setDeviatingCoeffs = async (
  coef: string,
  state: any,
  dispatch: React.Dispatch<any>
) => {
  const updatedCoefficients = state.billingDetails.deviatingCoefficients.map(
    (option: any) => {
      return {
        ...option,
        coefficient: option.type == 1 ? coef : option.coefficient,
      };
    }
  );

  dispatch({
    type: UPDATE_FIELDS,
    tab: BILLING_DETAILS,
    field: "deviatingCoefficients",
    value: updatedCoefficients,
  });
};
